import Accordion from "@/common/components/Accordion"
import Table from "@/common/components/Table"
import { defaultColumns } from "@/features/establishmentLeadsFunnel/constants/lastTransactionsColumns.constant"
import { ConsumptionsTransformer } from "@/features/establishmentLeadsFunnel/services/consumptionsTransformer"
import { EstablishmentLeadData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"

interface LastTransactionsSectionProps {
  first_complete_consumption_per_capture_method: EstablishmentLeadData['first_complete_consumption_per_capture_method'],
  isPending?: boolean,
}

export const LastTransactionsSection = ({
  first_complete_consumption_per_capture_method
}: LastTransactionsSectionProps) => {
  return (
    <Accordion
      head={<p>Últimas transações</p>}
      body={
        <Table
          columns={defaultColumns}
          isLoadingData={false}
          rows={
            first_complete_consumption_per_capture_method
              ? ConsumptionsTransformer.tableTransformer()(first_complete_consumption_per_capture_method)
              : []
          }
          page={1}
          totalPages={1}
        />
      }
    />
  )
}
